module.exports = __webpack_public_path__ + "static/4_2_nearest-neighbor_HR-9a8384ea85892929c4d73a6ee07d074a.svg";